import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';


import * as _ from 'lodash-es';
declare var require: any;

@Component({
  selector: 'app-safetyzones',
  templateUrl: './safetyzones.component.html',
  styleUrls: ['./safetyzones.component.scss']
})
export class SafetyzonesComponent implements OnInit {

  safety_zone: any;
  safety_zones: any;
  id?: number;
  view: any;
  sort = 'name';

  formGroup = new FormGroup ({
    search: new FormControl('',[])
  });

  nameFormGroup = new FormGroup ({
    name: new FormControl('',[Validators.required])
  });

  submitted = false;

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  get f(): { [key: string]: AbstractControl } {
    return this.nameFormGroup.controls;
  }

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.pagination.page = 1;
    this.getSafetyZones();

  }

  getSafetyZones(){

    let filter = {
      sort: this.sort,
      search: this.formGroup.value.search,
      page: this.pagination.page,
    }

    //console.log('filter', filter);

    this.okService.get("safetyzones",filter)
    .subscribe((data) => {

      this.safety_zones = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;


      //console.log(this.safety_zones);

    });

  }

  submitForm(){
    //console.log("submitForm()");

    if(this.submitted){
      Object.keys(this.nameFormGroup.controls).forEach(key => {
        this.nameFormGroup.get(key)?.setErrors({ invalid: null });
        this.nameFormGroup.get(key)?.updateValueAndValidity();
      });
    }

    this.submitted = true;

    if (this.nameFormGroup.valid) {
      let values = this.nameFormGroup.value

      this.okService.post("safetyzones",values)
      .subscribe({
          next: (data) => {
            this.safety_zone = data.body;

            //console.log("nameFormGroup submit", this.safety_zone);

            let id = this.safety_zone.id

            this.router.navigateByUrl("/mgmt/safetyzones/"+id);

          },
          error: (e) => {

            //console.log("Setup the error",Array.isArray(e));
            //console.log(e);

            if(Array.isArray(e)){
              let self = this;

              //console.log("Setup the error",e);

              // Use of _.forEach() method
              _.forEach(e, function(error:any) {
                //console.log(error);
                self.nameFormGroup.get(error.field)?.setErrors({ invalid: error.message });


                //console.log(error.field,error.message);

              });
            }else{
              this.okService.setAlert(e,"warning")
            }


          },
          complete: () => {
            //console.info('complete');
          }
      });
    }

  }

  changePage(){
    this.getSafetyZones();
  }

  updateFilter(){
    if(this.formGroup.valid){
      this.getSafetyZones();
    }
  }

  countWorkers(workers: any){
    return workers.length;
  }

  cancelSearch(){
    this.formGroup.setValue({
      search: ''
    });
    this.updateFilter();

  }
}
